import * as React from "react";
import "./IconItemGrid.sass"
import "../../common.sass"
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import InfoMessage from "./InfoMessage";
import {ADDRESS} from "../../../_api/client";
import {useEffect, useState} from "react";

export const IconItemGridType = {
    COMMON: 'common',
    PHONE: 'phone',
    FULL: 'full'
}

export default function IconItemGrid(props) {
    const {Icon, message} = props
    const {title, backgroundColor, link, type, alt, svg, selected} = props

    const select = selected ? 'icon-item-grid-wrapper-selected' : '';

    const [svgBody, setSvgBody] = useState(null);

    useEffect(() => {
        if (svg) {
            fetch(`${ADDRESS}/avatar/svg/${svg}`)
                .then(res => res.text())
                .then(setSvgBody)
        }
    }, [svg]);

    return (
        <Link to={link || '/'}
              style={{backgroundColor: backgroundColor}}
              className={`icon-item-grid-wrapper ${type} ${select}`}>
            <div className="icon-item-grid-content">
                {
                    svg
                        ? <div className="icon-item-grid-icon"
                               dangerouslySetInnerHTML={{__html: svgBody}}>
                        </div>
                        : <div className="icon-item-grid-icon">
                            {/*{svg && <div dangerouslySetInnerHTML={{__html: svg}}></div>}*/}
                            {Icon && <Icon />}
                            {alt && <div style={{color: 'white', fontWeight: 'bold'}}>{alt} BYN</div>}
                            {message}
                        </div>
                }

                <div className={`icon-item-grid-title ${select}`}>
                    <span>{title}</span>
                </div>
            </div>
        </Link>
    )
}

IconItemGrid.propTypes = {
    Icon: PropTypes.object,
    title: PropTypes.string,
    backgroundColor: PropTypes.string,
    link: PropTypes.string,
    type: PropTypes.string,
    selected: PropTypes.bool,
    message: PropTypes.objectOf(InfoMessage),
    alt:PropTypes.string,
    svg:PropTypes.string,
}